const { Configuration, OpenAIApi } = require("openai");
const configuration = new Configuration({
  apiKey: "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",
});

const openai = new OpenAIApi(configuration);

const ocrwebservice = async (file) => {
  try {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("language", "eng");
    formData.append("apikey", "K84792312088957");

    const url = "https://api.ocr.space/parse/image";
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    console.log(data);
    return {
      status: true,
      data: data,
      message: "OCR text fetched successfully.",
    };
  } catch (e) {
    console.error("There was a problem with the OCRWebService API request:", e);
    return {
      status: false,
      message: "There was a problem with the OCRWebService API request",
    };
  }
};

const ParseOCRText = async (text) => {
  const response = await openai.createCompletion({
    model: "text-davinci-003",
    prompt:
      text +
      "\nremove incomplete questions and provide json array which will contain question and options  use key question and options in json format:",
    temperature: 0.7,
    max_tokens: 3188,
    top_p: 1,
    frequency_penalty: 0,
    presence_penalty: 0,
  });

  return { status: true, data: response.data.choices };
};

export const ImageToQuestionArray = async (file) => {
  try {
    const ocrResponse = await ocrwebservice(file);
    if (ocrResponse.status) {
      const parseResponse = await ParseOCRText(
        ocrResponse.data.ParsedResults[0].ParsedText
      );
      if (parseResponse.status) {
        return {
          status: true,
          data: JSON.parse(parseResponse.data[0]?.text),
          message: "Question array fetched successfully.",
        };
      } else {
        return { status: false, message: parseResponse.message };
      }
    } else {
      return { status: false, message: ocrResponse.message };
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
